// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1WODI","header":"PatientBlock_header__3WvEl","label":"PatientBlock_label__2AB1g","option":"PatientBlock_option__P6MOm"};